import sliceCreator from '../../index.jsx';
import {CREATE_MONTHLY_TARGET} from '../../../constants/index.jsx';
const _createMonthlyTargetAction = sliceCreator('CREATE_MONTHLY_TARGET', CREATE_MONTHLY_TARGET, 'post');

const { asyncAction: createMonthlyTargetAction, reducer, clearData: clearCreateMonthlyTargetAction } = _createMonthlyTargetAction;

export default reducer;

export {
    createMonthlyTargetAction,
    clearCreateMonthlyTargetAction
}